import cn from 'classnames'
import type { ReactNode } from 'react'

import styles from './CockpitSegmentedControlAccent.module.scss'

interface ICockpitSegmentedControlAccentProps {
  children: ReactNode
  withDefaultBackground?: boolean
  stretched?: boolean
  /** Sized and coloured for a card header's control row: a 28px white chip whose chosen segment
   *  takes the ink, as the row's switched-on chips do. */
  inHeader?: boolean
  className?: string
}

export const CockpitSegmentedControlAccent = ({
  children,
  withDefaultBackground = false,
  stretched = false,
  inHeader = false,
  className,
}: ICockpitSegmentedControlAccentProps) => (
  <div
    className={cn(
      styles.root,
      {
        [styles.defaultBackground]: withDefaultBackground,
        [styles.stretched]: stretched,
        [styles.inHeader]: inHeader,
      },
      className
    )}
  >
    {children}
  </div>
)

CockpitSegmentedControlAccent.displayName = 'CockpitSegmentedControlAccent'
